import { useCallback, useContext } from "react";
import { pendoTrack } from "@linkfluence/core/pendo";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentWorkspace } from "@radarly/core/workspace/use-cases";
import { DiscoveryDetailsPanel } from "@radarly/models/panel";
import { Action } from "../action";
import ChannelContext from "../context";

export function useOpenDiscoveryDetailsPanel() {
  const project = useCurrentProject();
  const workspace = useCurrentWorkspace();
  const { dispatch } = useContext(ChannelContext);
  return useCallback(
    (
      meta: DiscoveryDetailsPanel["meta"],
      detailsTemplate: DiscoveryDetailsPanel["detailsTemplate"]
    ) => {
      pendoTrack("discovery_details_open", {
        project_id: String(project.id),
        project_name: project.label,
        workspace_id: String(workspace.id),
        workspace_name: workspace.label,
      });
      dispatch(
        Action.panelOpened({
          type: "discovery-details",
          meta,
          detailsTemplate,
        })
      );
    },
    [dispatch, project.id, project.label, workspace.id, workspace.label]
  );
}
